import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['template', 'container']

  add (event) {
    event.preventDefault()

    const uniqueId = new Date().getTime()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, uniqueId)
    this.containerTarget.insertAdjacentHTML('beforeend', content)
  }

  remove (event) {
    event.preventDefault()
    event.target.closest('[data-nested-fields-target="fields"]')?.remove()
  }
}
